/** Human-readable screen ids for `screen_view` (stable for GA4 reports). */
const PATH_TO_SCREEN: Record<string, string> = {
  "/": "pvp_game",
  "/rewards": "rewards",
  "/profile": "profile",
  "/inventory": "inventory",
  "/pvp-roulette-history": "pvp_history",
  "/tournament-leaderboard": "tournament_leaderboard",
}

export function resolveScreenName(pathname: string): string {
  if (PATH_TO_SCREEN[pathname]) return PATH_TO_SCREEN[pathname]
  if (pathname.startsWith("/dev/")) return "dev"
  return "other"
}
